<style src="./FormFileInput.scss" lang="scss" scoped></style>
<template>
  <section class="form-file-input">
    <div
      class="drop-zone"
      @dragover="isDragOver"
      @dragenter="isDragOver"
      @dragleave="isDragLeave"
      @dragend="isDragLeave"
      @drop="isDrop"
      :class="{'drop-zone-over': dragOverClass}"
      v-show="uploadStage === 'UPLOAD'">
      <label class="input-label">
        <input
          type="file"
          class="input-file"
          accept=".xlsx"
          @change="isChoosed">

        <icon-upload class="icon"/>
        <h3>Respositório de arquivo</h3>
        <h5>Arraste o arquivo de mapa ou clique para escolhe-lo</h5>
      </label>
    </div>

    <div
      class="wait"
      v-show="uploadStage === 'WAIT'">
      <icon-wait class="icon" />
      <h3>Processando o arquivo</h3>
      <h5>Aguarde...</h5>
    </div>
  </section>
</template>

<script>
import GenerateProposal from '@/brain/event-detail/GenerateProposal'
import { IconWait, IconUpload } from '@/components/primitives/icons'

export default {
  name: 'FormFileInput',
  components: {
    IconWait,
    IconUpload
  },
  props: {
    formData: {
      default: null
    }
  },
  data () {
    return {
      dragOverClass: false,
      uploadStage: 'UPLOAD'
    }
  },
  methods: {
    isDragOver (e) {
      e.preventDefault()
      e.stopPropagation()

      if (!this.dragOverClass) this.dragOverClass = true
    },
    isDragLeave (e) {
      e.preventDefault()
      e.stopPropagation()

      if (this.dragOverClass) this.dragOverClass = false
    },
    isDrop (e) {
      e.preventDefault()
      e.stopPropagation()
      if (this.dragOverClass) this.dragOverClass = false
      this.readFile(e.dataTransfer.files[0])
    },
    isChoosed (e) {
      e.preventDefault()
      e.stopPropagation()
      this.readFile(e.target.files[0])
    },
    readFile (pFile) {
      if (this.dragOverClass) this.dragOverClass = false
      this.uploadStage = 'WAIT'
      GenerateProposal(pFile, this.formData)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'PROPOSTA.xlsx')
          document.body.appendChild(link)
          link.click()
          this.uploadStage = 'UPLOAD'
        })
        .catch(() => {
          this.uploadStage = 'UPLOAD'
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event-detail/proposal/components/form-file-input/FormFileInput.vue